const injectCrazyEgg = () => {
  const script = document.createElement('script')
  script.type = 'text/javascript'
  script.src = '//script.crazyegg.com/pages/scripts/0119/9791.js'
  script.async = true
  script.id = 'crazyegg-script' // Add an ID to prevent duplicate loading
  document.head.appendChild(script)
}

export const loadCrazyEgg = () => {
  // Check if the Crazy Egg script is already loaded
  if (document.getElementById('crazyegg-script')) {
    console.log('Crazy Egg script is already loaded')
    return
  }

  injectCrazyEgg()
  console.log('Crazy Egg script loaded successfully')
}
